import { render, staticRenderFns } from "./FactureCeder.vue?vue&type=template&id=da2c9632&scoped=true&"
import script from "./FactureCeder.vue?vue&type=script&lang=ts&"
export * from "./FactureCeder.vue?vue&type=script&lang=ts&"
import style0 from "./FactureCeder.vue?vue&type=style&index=0&id=da2c9632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c9632",
  null
  
)

export default component.exports